import styled from "styled-components";
import { IStyleElement } from "~/types/types";
import breakpoints from "./breakpoints";

interface Props extends IStyleElement {
  [key: string]: any
}

const Image = styled.img<Props>`
  ${p => p.xsStyle}
  ${breakpoints.sm} {
    ${p => p.smStyle}
  }
  ${breakpoints.md} {
    ${p => p.mdStyle}
  }
  ${breakpoints.lg} {
    ${p => p.lgStyle}
  }
  ${breakpoints.xl} {
    ${p => p.xlStyle}
  }
`

const Img: React.FC<Props> = (props) => <Image loading='lazy' {...props} />

export default Img